module.exports = __webpack_public_path__ + "static/media/book_online_black_24dp.798e9245.svg";